import { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { navLinks } from '@/mocks/home';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleNavClick = (href: string) => {
    setMobileOpen(false);
    if (href.startsWith('#')) {
      const el = document.querySelector(href);
      if (el) {
        el.scrollIntoView({ behavior: 'smooth' });
      }
    } else if (href === '/') {
      navigate('/');
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-10 flex items-center justify-between h-16 md:h-18">
        <a
          href="/"
          onClick={(e) => {
            e.preventDefault();
            handleNavClick('/');
          }}
          className="flex items-center gap-2.5 cursor-pointer"
        >
          <div className="w-9 h-9 md:w-10 md:h-10 flex items-center justify-center rounded-lg bg-accent-500">
            <i className="ri-book-read-line text-background-50 text-lg md:text-xl"></i>
          </div>
          <span className="font-heading text-lg md:text-xl font-bold text-foreground-950 tracking-wide whitespace-nowrap">
            歪歪漫画
          </span>
        </a>

        <div className="hidden md:flex items-center gap-1">
          {navLinks.map((link) => (
            <a
              key={link.label}
              href={link.href}
              onClick={(e) => {
                e.preventDefault();
                handleNavClick(link.href);
              }}
              className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors duration-200 whitespace-nowrap cursor-pointer ${
                location.pathname === '/' && link.href === '/'
                  ? 'text-accent-600'
                  : 'text-foreground-700 hover:text-foreground-950 hover:bg-background-100'
              }`}
            >
              {link.href === '/features' && (
                <span className="inline-block w-2 h-2 rounded-full bg-accent-500 mr-1.5 align-middle"></span>
              )}
              {link.label}
            </a>
          ))}
        </div>

        <div className="hidden md:flex items-center gap-3">
          <a
            href="#hot"
            onClick={(e) => {
              e.preventDefault();
              handleNavClick('#hot');
            }}
            className="px-5 py-2 rounded-full bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
          >
            立即阅读
          </a>
        </div>

        <button
          className="md:hidden w-9 h-9 flex items-center justify-center rounded-lg text-foreground-700 hover:bg-background-100 transition-colors duration-200 cursor-pointer"
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-label="Toggle menu"
        >
          <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
        </button>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70">
          <div className="px-4 py-4 flex flex-col gap-1">
            {navLinks.map((link) => (
              <a
                key={link.label}
                href={link.href}
                onClick={(e) => {
                  e.preventDefault();
                  handleNavClick(link.href);
                }}
                className="px-4 py-3 rounded-lg text-sm font-medium text-foreground-700 hover:text-foreground-950 hover:bg-background-100 transition-colors duration-200 cursor-pointer"
              >
                {link.label}
              </a>
            ))}
            <a
              href="#hot"
              onClick={(e) => {
                e.preventDefault();
                handleNavClick('#hot');
              }}
              className="mt-2 px-4 py-3 rounded-full bg-primary-500 text-background-50 text-sm font-medium text-center hover:bg-primary-600 transition-colors duration-200 cursor-pointer"
            >
              立即阅读
            </a>
          </div>
        </div>
      )}
    </nav>
  );
}